import SessionStorageService from 'services/authentication/storage/session';
import UserStorageService from 'services/authentication/storage/user';

const logoutUseCase = async () => {
  SessionStorageService.clear();
  UserStorageService.clear();
};

export default logoutUseCase;
